import { Api } from '../modules/Service';

const MBikeTransmission = {
  list: () => {
    return Api('/bike_transmission/list');
  },
  add: data => {
    return Api('/bike_transmission/new', JSON.stringify(data), 'POST', 'text');
  },
  update: data => {
    return Api(
      '/bike_transmission/set/' + data.id,
      JSON.stringify(data),
      'POST',
      'text',
    );
  },
  delete: id => {
    return Api('/bike_transmission/del/' + id, {}, 'GET', 'text');
  },
  get: id => {
    return Api('/bike_transmission/get/' + id);
  },
};
export default MBikeTransmission;
